import type { UmamiEvents } from '@/lib/umami/umami-events';
import { WebAuthnError } from '@simplewebauthn/browser';

type SigninFailure = UmamiEvents['signin-failed'];

/**
 * Why a sign-in failed, as the funnel needs it: never the message, only which kind.
 *
 * A passkey failure is told apart by its class. @simplewebauthn/browser wraps the browser's
 * DOMException in a WebAuthnError that keeps its name (NotAllowedError, AbortError), so both
 * are checked. Anything else with a name and no status, a dropped connection's TypeError for
 * one, is an `error`: the screen's looser isCeremonyError would count it as a passkey problem
 * and make an API outage read as one in the reports.
 */
export const signinFailureReason = (ex: unknown, method: SigninFailure['method']): SigninFailure['reason'] => {
  if (ex instanceof WebAuthnError || ex instanceof DOMException) {
    return ex.name === 'NotAllowedError' || ex.name === 'AbortError' ? 'passkey-cancelled' : 'passkey-rejected';
  }
  const { status } = (ex ?? {}) as { status?: number };
  if (status === 401) return method === 'passkey' ? 'passkey-rejected' : 'wrong-credentials';
  return 'error';
};
